import api from "apis/appraiserCounties";
import { HTTP_GET, HTTP_POST, WebApiReduxRequest, WebApiReduxRequestWithCallback } from "tools/webservice";
import {
  REQUEST_APPRAISER_COUNTIES,
  RECEIVE_APPRAISER_COUNTIES,
  ERROR_APPRAISER_COUNTIES,

  REQUEST_SET_APPRAISER_COUNTIES,
  RECEIVE_SET_APPRAISER_COUNTIES,
  ERROR_SET_APPRAISER_COUNTIES,

  REQUEST_MULTIPLE_APPRAISER_COUNTIES,
  RECEIVE_MULTIPLE_APPRAISER_COUNTIES,
  ERROR_MULTIPLE_APPRAISER_COUNTIES,
} from "typeConstants";

export const getAppraiserCounties = (appraiserNumber) => {
  return WebApiReduxRequest(
    REQUEST_APPRAISER_COUNTIES,
    RECEIVE_APPRAISER_COUNTIES,
    ERROR_APPRAISER_COUNTIES,
    HTTP_GET,
    api.getAppraiserCounties(appraiserNumber),
  );
};

export const setAppraiserCounties = (appraiserId, counties, callback) => {
  return WebApiReduxRequestWithCallback(
    REQUEST_SET_APPRAISER_COUNTIES,
    RECEIVE_SET_APPRAISER_COUNTIES,
    ERROR_SET_APPRAISER_COUNTIES,
    HTTP_POST,
    api.setAppraiserCounties(appraiserId),
    callback,
    counties.map(c => c.id),
  );
};

export const getMultipleAppraiserCounties = (appraiserNumbers) => {
  return WebApiReduxRequest(
    REQUEST_MULTIPLE_APPRAISER_COUNTIES,
    RECEIVE_MULTIPLE_APPRAISER_COUNTIES,
    ERROR_MULTIPLE_APPRAISER_COUNTIES,
    HTTP_POST,
    api.getMultipleAppraiserCounties(),
    appraiserNumbers,
  );
};
